import {NOTIFICATION_LIST, NOTIFICATION_LIST_ALL, NOTIFICATION_COUNT} from './action';

const initialState = {
    notificationList : null,
    notificationListAll : null,
    notificationCount: 0
}

function notificationReducer(state = initialState, action: { type: any; payload: any; }){
    switch (action.type) {
        case NOTIFICATION_LIST:
            return { ...state, notificationList: action.payload };
        case NOTIFICATION_LIST_ALL:
            return { ...state, notificationListAll: action.payload };
        case NOTIFICATION_COUNT:
            return { ...state, notificationCount: action.payload };
        default:
            return state;
    }
}

export default notificationReducer;